import React from "react";
import CustomPage from "../../lib/Pages/Customizable";

export default function Page() {
  return <CustomPage />;
}
